import { combineReducers } from 'redux';
import host from './host';
import customerLinks from './customer-links';

export default combineReducers({
  host,
  customerLinks,
});
